webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(58);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(53);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: 'body',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(17)
	__vue_template__ = __webpack_require__(52)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(2);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(18);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Fabric = __webpack_require__(54);
	
	var _Fabric2 = _interopRequireDefault(_Fabric);
	
	var _Zoom = __webpack_require__(11);
	
	var _Zoom2 = _interopRequireDefault(_Zoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jQuery = __webpack_require__(7);
	
	exports.default = {
	  components: {
	    Fabric: _Fabric2.default,
	    Zoom: _Zoom2.default
	  },
	  data: function data() {
	    return {
	      currentView: 'fabric',
	      count: 0,
	      msg: Object,
	      session: Object,
	      flash: Object,
	      isactive: [],
	      baseurl: window.stoffmuster['baseurl'],
	      invurl: window.stoffmuster.invurl,
	      checkoutUrl: '',
	      isloggedin: window.stoffmuster.loggedin,
	      measurementblock: window.stoffmuster.measurementblock,
	      imgcaption: window.stoffmuster.translations.imgcaption,
	      seoblock: window.stoffmuster.translations.seoBlock,
	      addtocart: window.stoffmuster.translations['Add to Cart'],
	      translations: window.stoffmuster.translations,
	      priceInfo: window.stoffmuster.priceInfo,
	      selects: [],
	      personal: { muster1: '', muster2: '', muster3: '', muster4: '', configure_id: '0' },
	      defaults: { muster1: '', muster2: '', muster3: '', muster4: '', configure_id: '0' },
	      steps: ['Stoff'],
	      fabrics: [],
	      designName: 'Mein Design',
	      design: [],
	      designId: window.stoffmuster.designId,
	      selectItems: [],
	      currentData: {},
	      globals: window.stoffmuster,
	      selectBox: [],
	      zoom: { img: '', title: '', text: '', price: '' },
	      'summary': [],
	      'showModal': false
	    };
	  },
	  props: {
	    show: {
	      type: Boolean,
	      required: true,
	      twoWay: true
	    }
	  },
	  created: function created() {
	    if (localStorage.getItem('swatch_configure_id') > 0) {
	      this.personal['configure_id'] = localStorage.getItem('swatch_configure_id');
	      localStorage.setItem('swatch_configure_id', 0);
	    }
	    this.getCheckoutUrl();
	    jQuery.getJSON(this.baseurl + '/designer/ajax/getFabricList', { swatch: '1' }, function (data) {
	      this.fabrics = data;
	      this.personal = this.getPersonalData();
	    }.bind(this));
	  },
	  computed: {
	    url1: function url1() {
	      return this.personal['muster1'] ? this.baseurl + 'media/' + this.currentData.muster1.zoom : '';
	    },
	    url2: function url2() {
	      return this.personal['muster2'] ? this.baseurl + 'media/' + this.currentData.muster2.zoom : '';
	    },
	    url3: function url3() {
	      return this.personal['muster3'] ? this.baseurl + 'media/' + this.currentData.muster3.zoom : '';
	    },
	    url4: function url4() {
	      return this.personal['muster4'] ? this.baseurl + 'media/' + this.currentData.muster4.zoom : '';
	    }
	  },
	  methods: {
	    getPersonalData: function getPersonalData() {
	      var result = {};
	      var data = this.personal;
	      if (data !== undefined) {
	        var keys = (0, _keys2.default)(data);
	        var i = 0;
	        var key;
	        while (keys[i]) {
	          key = keys[i];
	          result[key] = localStorage.getItem(key) ? JSON.parse(localStorage[key]) : data[key];
	          if (result[key] !== '') {
	            this.setCurrentData(result[key], key);
	            this.isactive.push(result[key]);
	          }
	          i++;
	        }
	      }
	      return result;
	    },
	    resetConfig: function resetConfig() {
	      var data = this.personal;
	      var keys = (0, _keys2.default)(data);
	      var key;
	      var i = 0;
	      while (keys[i]) {
	        key = keys[i];
	        this.personal[key] = this.defaults[key];
	        if (localStorage.getItem(key)) {
	          localStorage.removeItem(key);
	        }
	        i++;
	      }
	      this.personal = this.defaults;
	      this.currentData = {};
	    },
	    addToCart: function addToCart() {
	      if (!this.personal['muster1'] && !this.personal['muster2'] && !this.personal['muster3'] && !this.personal['muster4']) {
	        this.setMessage({ 'error': this.translations['Please select at least 1 fabric.'] });
	      } else {
	        jQuery('#product_addtocart_form').submit().done(this.resetConfig());
	      }
	    },
	    getCheckoutUrl: function getCheckoutUrl() {
	      if (this.personal['configure_id'] > 0) {
	        this.checkoutUrl = window.stoffmuster['baseurl'] + 'checkout/cart/updateItemOptions/id/' + this.personal['configure_id'] + '/';
	      } else {
	        jQuery.getJSON(window.stoffmuster['baseurl'] + 'designer/ajax/getAddToCartUrl', { type: 'stoffmuster' }, function (data) {
	          var getCheckoutUrl = data;
	          getCheckoutUrl = getCheckoutUrl.checkoutUrl;
	          this.checkoutUrl = getCheckoutUrl;
	        }.bind(this));
	      }
	    },
	    remove: function remove(event) {
	      var val = event.currentTarget.id;
	      var i;
	      var key;
	      for (i = 1; i < 5; i++) {
	        key = 'muster' + i;
	        if (this.personal[key] === val) {
	          this.personal[key] = '';
	          localStorage.removeItem(key);
	        }
	      }
	      var index = this.isactive.indexOf(val);
	      if (index > -1) {
	        this.isactive.splice(index, 1);
	      }
	    },
	    setMessage: function setMessage(msg) {
	      this.flash = msg;
	      jQuery('#flash').fadeIn('slow').delay(2000).fadeOut('slow');
	    },
	    zoomFabric: function zoomFabric(event) {
	      this.zoom = {
	        img: this.baseurl + 'media/' + event.currentTarget.dataset.zoom,
	        title: event.currentTarget.dataset.title,
	        infotext: event.currentTarget.dataset.infotext,
	        weight: event.currentTarget.dataset.weight,
	        composition: event.currentTarget.dataset.composition,
	        weave: event.currentTarget.dataset.weave,
	        yarn: event.currentTarget.dataset.yarn,
	        refnr: event.currentTarget.dataset.refnr,
	        price: Number(event.currentTarget.dataset.price).toFixed(2)
	      };
	      this.show = true;
	    },
	    setCurrentData: function setCurrentData(sku, index) {
	      this.currentData[index] = jQuery.grep(this.fabrics, function (e) {
	        return e.ref_number === sku;
	      })[0];
	    }
	  },
	  events: {
	    getFabricData: function getFabricData(event) {
	      var selectorId = event.currentTarget.id;
	      window.stoffmuster.extraPrices['fabric'] = event.currentTarget.dataset.price;
	      if (selectorId !== '') {
	        jQuery.getJSON(window.stoffmuster['baseurl'] + 'designer/ajax/getList', { target: 'fabric', qlty: selectorId, type: 'shirt' }, function (data) {
	          this.fabrics = data;
	        }.bind(this));
	      }
	    },
	    updatePersonalData: function updatePersonalData(data) {
	      if (data[0].length && data[1] !== undefined) {
	        if (data !== undefined) {
	          var keys = (0, _keys2.default)(this.personal);
	          var i = 0;
	          var key;
	          var remove = false;
	          var personal = this.personal;
	          (0, _keys2.default)(personal).forEach(function (key) {
	            if (personal[key] === data[1]) {
	              personal[key] = '';
	              localStorage.removeItem(key);
	              remove = true;
	            }
	          });
	          if (!remove) {
	            while (keys[i]) {
	              key = keys[i];
	              if (this.personal[key] === '') {
	                this.personal[key] = data[1];
	                this.setCurrentData(data[1], key);
	                localStorage.setItem(key, (0, _stringify2.default)(data[1]));
	                break;
	              } else {
	                i++;
	                continue;
	              }
	            }
	          }
	        }
	      }
	    },
	    setSwatch: function setSwatch(object) {
	      this[object.key] = object.value;
	      this.personal[object.key] = object.value;
	      this.setCurrentData(object.value, object.key);
	      console.log(object);
	    },
	    setMsg: function setMsg(msg) {
	      this.setMessage(msg);
	    }
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Filter = __webpack_require__(56);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _Filtersuit = __webpack_require__(57);
	
	var _Filtersuit2 = _interopRequireDefault(_Filtersuit);
	
	var _Fabrics = __webpack_require__(55);
	
	var _Fabrics2 = _interopRequireDefault(_Fabrics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jQuery = __webpack_require__(7);
	
	exports.default = {
	  name: 'Fabric',
	  data: function data() {
	    return {
	      showPattern: false,
	      showColor: false,
	      showWeave: false,
	      showMaterial: false,
	      showOccasion: false,
	      showPrice: false,
	      showSeason: false,
	      filtercolor: '',
	      filterpattern: '',
	      filterweave: '',
	      filtermaterial: '',
	      filteroccasion: '',
	      filtername: '',
	      activeType: 'shibl',
	      fields: ['name', 'color', 'weave', 'season', 'occasion', 'pattern', 'material'],
	      boolfilter: { 'topseller': '0', 'new': '0' },
	      range1: { value: 49, min: 49, max: 99 },
	      range2: { value: 99, min: 50, max: 99 },
	      globals: window.stoffmuster,
	      translations: window.stoffmuster.translations,
	      scrolling: false
	    };
	  },
	  components: {
	    Filter: _Filter2.default,
	    Filtersuit: _Filtersuit2.default,
	    Fabrics: _Fabrics2.default
	  },
	  props: {
	    'baseurl': String,
	    'personal': Object,
	    'fabrics': Array,
	    'zoom': Object,
	    'filtercolor': String,
	    'filterpattern': String,
	    'filterweave': String,
	    'filtermaterial': String,
	    'filteroccasion': String,
	    'filtername': String,
	    'muster1': String,
	    'muster2': String,
	    'muster3': String,
	    'muster4': String,
	    'isactive': Array,
	    'currentData': Object,
	    show: {
	      type: Boolean,
	      required: true,
	      twoWay: true
	    }
	  },
	  events: {
	    setFilter: function setFilter(event, callback) {
	      switch (event.currentTarget.dataset.select) {
	        case 'color':
	          if (event.currentTarget.id === 'all') {
	            this.filtercolor = '';
	            this.showColor = false;
	            callback('Color');
	          } else {
	            this.filtercolor = event.currentTarget.id;
	            callback(this.filtercolor);
	          }
	          break;
	        case 'pattern':
	          if (event.currentTarget.id === 'all') {
	            this.filterpattern = '';
	            this.showPattern = false;
	            callback('Pattern');
	          } else {
	            this.filterpattern = event.currentTarget.id;
	            callback(this.filterpattern);
	          }
	          break;
	        case 'weave':
	          if (event.currentTarget.id === 'all') {
	            this.filterweave = '';
	            this.showWeave = false;
	            callback('Weave');
	          } else {
	            this.filterweave = event.currentTarget.id;
	            callback(this.filterweave);
	          }
	          break;
	        case 'material':
	          if (event.currentTarget.id === 'all') {
	            this.filtermaterial = '';
	            this.showMaterial = false;
	            callback('Material');
	          } else {
	            this.filtermaterial = event.currentTarget.id;
	            callback(this.filtermaterial);
	          }
	          break;
	        case 'occasion':
	          if (event.currentTarget.id === 'all') {
	            this.filteroccasion = '';
	            this.showOccasion = false;
	            callback('Occasion');
	          } else {
	            this.filteroccasion = event.currentTarget.id;
	            callback(this.filteroccasion);
	          }
	          break;
	        case 'name':
	          this.filtername = event.currentTarget.value;
	          callback(this.filtername);
	          break;
	      }
	    },
	    checkDesign: function checkDesign(event) {
	      this.$dispatch('mainCheckDesign', event, function () {});
	    },
	    setBoolFilter: function setBoolFilter(event, callback) {
	      if (this.boolfilter[event.currentTarget.id] !== '1') {
	        this.boolfilter[event.currentTarget.id] = '1';
	        callback('1');
	      } else {
	        this.boolfilter[event.currentTarget.id] = '0';
	        callback('0');
	      }
	    },
	    resetFilter: function resetFilter() {
	      this.resetFilter();
	    }
	  },
	  methods: {
	    selectFabric: function selectFabric(event) {
	      this.$dispatch('getFabricData', event);
	    },
	    showFilter: function showFilter(event) {
	      this.resetFilter();
	      var t = event.currentTarget.id.substr(0, event.currentTarget.id.indexOf('Button'));
	      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1);
	      this[f] = 'true';
	    },
	    thumbUrl: function thumbUrl(event) {
	      return this.baseurl + event.currentTarget.dataset.thumb;
	    },
	    resetBoolFilter: function resetBoolFilter() {
	      var b;
	      for (b in this.boolfilter) {
	        this.boolfilter[b] = '0';
	      }
	    },
	    setCurrentData: function setCurrentData(sku) {
	      this.currentData = jQuery.grep(this.fabrics, function (e) {
	        return e.ref_number === sku;
	      })[0];
	    },
	    loadFabrics: function loadFabrics(event) {
	      if (event.currentTarget.id === 'suit') {
	        this.range1 = { value: 299, min: 299, max: 700 };
	        this.range2 = { value: 700, min: 300, max: 700 };
	      } else if (event.currentTarget.id === 'shibl') {
	        this.range1 = { value: 49, min: 49, max: 100 };
	        this.range2 = { value: 100, min: 50, max: 100 };
	      } else {
	        this.range1 = { value: 0, min: 0, max: 100 };
	        this.range2 = { value: 100, min: 0, max: 100 };
	      }
	      jQuery.getJSON(this.baseurl + 'designer/ajax/getFabricList', { type: event.currentTarget.id, swatch: 1 }, function (data) {
	        this.fabrics = data;
	      }.bind(this));
	      this.activeType = event.currentTarget.id;
	      this.resetFilter();
	    },
	    resetFilter: function resetFilter() {
	      this.showPattern = false;
	      this.showColor = false;
	      this.showWeave = false;
	      this.showMaterial = false;
	      this.showOccasion = false;
	      this.showSeason = false;
	      this.showPrice = false;
	      this.showName = false;
	      this.range1.value = this.range1.min;
	      this.range2.value = this.range2.max;
	      this.resetBoolFilter();
	      this.filtercolor = '';
	      this.filterpattern = '';
	      this.filterweave = '';
	      this.filtermaterial = '';
	      this.filteroccasion = '';
	      this.filtername = '';
	    }
	  },
	  created: function created() {
	    jQuery.getJSON(this.baseurl + 'designer/ajax/getFabricList', { type: 'shibl', swatch: 1 }, function (data) {
	      this.fabrics = data;
	    }.bind(this));
	    this.box = { 'component': 'fabric', 'title': 'Stoff', 'todo': 'Wählen Sie aus diesen Stoffen.' };
	  },
	  ready: function ready() {
	    this.$dispatch('runDesignJQuery');
	  }
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(2);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _Zoom = __webpack_require__(11);
	
	var _Zoom2 = _interopRequireDefault(_Zoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Fabrics',
	  components: {
	    Zoom: _Zoom2.default
	  },
	  props: ['baseurl', 'box', 'fabrics', 'filtercolor', 'filterpattern', 'filterweave', 'filtermaterial', 'filteroccasion', 'filtername', 'range1', 'range2', 'boolfilter', 'fields', 'personal', 'muster1', 'muster2', 'muster3', 'muster4', 'isactive', 'currentData', 'zoom'],
	  data: function data() {
	    return {
	      show: {
	        type: Boolean,
	        required: true,
	        twoWay: true
	      },
	      globals: window.stoffmuster,
	      scrolling: false,
	      touchstart: false,
	      translations: window.stoffmuster.translations,
	      selectedScrollHeight: document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0,
	      selectedClientHeight: document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0,
	      scrollPosition: 0
	    };
	  },
	  events: {
	    updatePersonal: function updatePersonal(event) {
	      this.updatePersonal(event);
	    }
	  },
	  methods: {
	    addSample: function addSample(event) {
	      var exists = false;
	      var message = '';
	      var free = '';
	      var keys = ['muster1', 'muster2', 'muster3', 'muster4'];
	      var i = 0;
	      var key;
	      while (keys[i]) {
	        key = keys[i];
	        if (localStorage.getItem(key)) {
	          if (event.currentTarget.dataset.refnr === JSON.parse(localStorage.getItem(key))) {
	            exists = key;
	            break;
	          }
	        } else {
	          if (!free) free = key;
	        }
	        i++;
	      }
	      if (!exists && free) {
	        localStorage.setItem(free, (0, _stringify2.default)(event.currentTarget.dataset.refnr));
	        this.$dispatch('setSwatch', { key: free, value: event.currentTarget.dataset.refnr });
	        this.isactive.push(event.currentTarget.dataset.refnr);
	        this.$dispatch('setMsg', { success: this.translations['Added to swatch box.'] });
	      } else {
	        if (exists) {
	          localStorage.removeItem(key);
	          this.$dispatch('setSwatch', { key: key, value: '' });
	          var index = this.isactive.indexOf(event.currentTarget.dataset.refnr);
	          if (index > -1) {
	            this.isactive.splice(index, 1);
	          }
	          message = this.translations['Removed from swatch box.'];
	          this.$dispatch('setMsg', { success: message });
	        } else {
	          message = this.translations['You have already four fabrics in swatch box.'];
	          this.$dispatch('setMsg', { error: message });
	        }
	      }
	    },
	    priceBetween: function priceBetween(a) {
	      if (a.price >= this.range1.value && a.price <= this.range2.value) {
	        return a;
	      }
	    },
	    topseller: function topseller(a) {
	      if (this.boolfilter['topseller'] === '1') {
	        if (a.topseller === '1') return a;
	      } else {
	        return a;
	      }
	    },
	    newFilter: function newFilter(a) {
	      if (this.boolfilter['new'] === '1') {
	        if (a.new === '1') return a;
	      } else {
	        return a;
	      }
	    },
	    zoomFabric: function zoomFabric(event) {
	      this.zoom = {
	        img: this.baseurl + 'media/' + event.currentTarget.dataset.zoom,
	        title: event.currentTarget.dataset.title,
	        infotext: event.currentTarget.dataset.infotext,
	        weight: event.currentTarget.dataset.weight,
	        composition: event.currentTarget.dataset.composition,
	        weave: event.currentTarget.dataset.weave,
	        yarn: event.currentTarget.dataset.yarn,
	        refnr: event.currentTarget.dataset.refnr,
	        price: Number(event.currentTarget.dataset.price).toFixed(2)
	      };
	      this.show = true;
	    },
	    scrolldown: function scrolldown() {
	      if (this.touchstart === false) {
	        var ele = document.getElementById(this.box.component);
	        var speed = 25;
	        var scroll = 5;
	        var $this = this;
	        this.scrolling = window.setInterval(function () {
	          ele.scrollTop = ele.scrollTop + scroll;
	          $this.itemsScroll();
	        }, speed);
	      }
	    },
	    scrollup: function scrollup() {
	      if (this.touchstart === false) {
	        var ele = document.getElementById(this.box.component);
	        var speed = 25;
	        var scroll = 5;
	        var $this = this;
	        this.scrolling = window.setInterval(function () {
	          ele.scrollTop = ele.scrollTop - scroll;
	          $this.itemsScroll();
	        }, speed);
	      }
	    },
	    mouseleave: function mouseleave() {
	      if (this.scrolling) {
	        window.clearInterval(this.scrolling);
	        this.scrolling = false;
	      }
	    },
	    touchstartup: function touchstartup() {
	      this.touchstart = true;
	      var ele = document.getElementById(this.box.component);
	      var speed = 25;
	      var scroll = 5;
	      var $this = this;
	      this.scrolling = window.setInterval(function () {
	        ele.scrollTop = ele.scrollTop - scroll;
	        $this.itemsScroll();
	      }, speed);
	    },
	    touchstartdown: function touchstartdown() {
	      this.touchstart = true;
	      var ele = document.getElementById(this.box.component);
	      var speed = 25;
	      var scroll = 5;
	      var $this = this;
	      this.scrolling = window.setInterval(function () {
	        ele.scrollTop = ele.scrollTop + scroll;
	        $this.itemsScroll();
	      }, speed);
	    },
	    touchend: function touchend() {
	      this.mouseleave();
	    },
	    checkMeasures: function checkMeasures() {
	      this.selectedScrollHeight = document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0;
	      this.selectedClientHeight = document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0;
	    },
	    itemsScroll: function itemsScroll() {
	      var ele = document.getElementById(this.box.component);
	      this.scrollPosition = ele.scrollTop;
	      this.checkMeasures();
	    }
	  },
	  watch: {
	    fabrics: function fabrics() {
	      this.checkMeasures();
	    },
	    filtercolor: function filtercolor() {
	      this.checkMeasures();
	    },
	    showcolor: function showcolor() {
	      this.checkMeasures();
	    },
	    filterpattern: function filterpattern() {
	      this.checkMeasures();
	    },
	    showpattern: function showpattern() {
	      this.checkMeasures();
	    },
	    filterweave: function filterweave() {
	      this.checkMeasures();
	    },
	    showweave: function showweave() {
	      this.checkMeasures();
	    },
	    filtermaterial: function filtermaterial() {
	      this.checkMeasures();
	    },
	    showmaterial: function showmaterial() {
	      this.checkMeasures();
	    },
	    filteroccasion: function filteroccasion() {
	      this.checkMeasures();
	    },
	    showoccasion: function showoccasion() {
	      this.checkMeasures();
	    },
	    filtername: function filtername() {
	      this.checkMeasures();
	    },
	    showname: function showname() {
	      this.checkMeasures();
	    },
	    range1: function range1() {
	      this.checkMeasures();
	    },
	    range2: function range2() {
	      this.checkMeasures();
	    },
	    showprice: function showprice() {
	      this.checkMeasures();
	    },
	    boolfilter: function boolfilter() {
	      this.checkMeasures();
	    }
	  },
	  ready: function ready() {
	    this.checkMeasures();
	  }
	};

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Filter',
	  data: function data() {
	    return {
	      translations: window.stoffmuster.translations
	    };
	  },
	  props: {
	    showPattern: Boolean,
	    showColor: Boolean,
	    showWeave: Boolean,
	    showMaterial: Boolean,
	    showOccasion: Boolean,
	    showPrice: Boolean,
	    showSeason: Boolean,
	    showNew: Boolean,
	    showTopseller: Boolean,
	    showName: Boolean,
	    filtercolor: String,
	    buttonColor: String,
	    classcolor: String,
	    filterpattern: String,
	    buttonPattern: String,
	    classpattern: String,
	    filterweave: String,
	    buttonWeave: String,
	    classweave: String,
	    filtermaterial: String,
	    buttonMaterial: String,
	    classmaterial: String,
	    filteroccasion: String,
	    buttonOccasion: String,
	    classoccasion: String,
	    buttonNew: String,
	    buttonTopseller: String,
	    buttonPrice: String,
	    filtername: String,
	    buttonName: String,
	    range1: Object,
	    range2: Object,
	    boolfilter: Object
	  },
	  methods: {
	    selectFabric: function selectFabric(event) {
	      this.$dispatch('getFabricData', event);
	    },
	    setFilter: function setFilter(event) {
	      var t = event.currentTarget.dataset.select;
	      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1);
	      var id = event.currentTarget.id === 'all' ? '' : event.currentTarget.id;
	      var cl = 'class' + t;
	      this[cl] = id.replace('100%', 'full');
	      this[f] = false;
	      this.$dispatch('setFilter', event, function (value) {
	        var b = 'button' + t.charAt(0).toUpperCase() + t.substr(1);
	        this[b] = window.stoffmuster.translations[value];
	      }.bind(this));
	      this.$dispatch('checkDesign', event, function () {});
	    },
	    setBoolFilter: function setBoolFilter(event) {
	      var t = event.currentTarget.id.substr(0, event.currentTarget.id.indexOf('Button'));
	      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1);
	      if (this[f] === true) {
	        this[f] = false;
	      } else {
	        this.resetFilter();
	        this[f] = true;
	      }
	      this.$dispatch('setBoolFilter', event, function () {});
	      this.$dispatch('checkDesign', event, function () {});
	    },
	    resetFilter: function resetFilter(event) {
	      this.showPattern = false;
	      this.showColor = false;
	      this.showWeave = false;
	      this.showMaterial = false;
	      this.showOccasion = false;
	      this.showSeason = false;
	      this.showPrice = false;
	      this.showName = false;
	      this.$dispatch('checkDesign', event, function () {});
	    },
	    realResetFilter: function realResetFilter() {
	      this.resetFilter();
	      this.$dispatch('resetFilter');
	      this.resetButtons();
	    },
	    showFilter: function showFilter(event) {
	      var t = event.currentTarget.id.substr(0, event.currentTarget.id.indexOf('Button'));
	      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1);
	      if (this[f] === true) {
	        this[f] = false;
	      } else {
	        this.resetFilter();
	        this[f] = true;
	      }
	      this.$dispatch('checkDesign', event, function () {});
	    },
	    closeName: function closeName() {
	      this.showName = false;
	    },
	    closePrice: function closePrice() {
	      this.showPrice = false;
	    },
	    range1max: function range1max() {
	      this.range1.max = this.range2.value;
	      if (this.range1.value !== this.range1.min || this.range2.value !== this.range2.max) {
	        this.buttonPrice = this.range1.value + ' - ' + this.range2.value + ' €';
	      } else {
	        this.buttonPrice = window.stoffmuster.translations['Price'];
	      }
	    },
	    range2min: function range2min() {
	      this.range2.min = this.range1.value;
	      if (this.range1.value !== this.range1.min || this.range2.value !== this.range2.max) {
	        this.buttonPrice = this.range1.value + ' - ' + this.range2.value + ' €';
	      } else {
	        this.buttonPrice = window.stoffmuster.translations['Price'];
	      }
	    },
	    nameChange: function nameChange(event) {
	      var t = event.currentTarget.dataset.select;
	      this.$dispatch('setFilter', event, function (value) {
	        var b = 'button' + t.charAt(0).toUpperCase() + t.substr(1);
	        if (value === '') {
	          this[b] = window.stoffmuster.translations['Name'];
	        } else {
	          this[b] = value;
	        }
	      }.bind(this));
	    },
	    setPriceRange: function setPriceRange(event) {
	      var min = parseInt(event.currentTarget.dataset.start);
	      var max = parseInt(event.currentTarget.dataset.end);
	      this.range1.value = min;
	      this.range2min();
	      this.range2.value = max;
	      this.range1max();
	      this.closePrice();
	    },
	    resetButtons: function resetButtons() {
	      this.buttonColor = window.stoffmuster.translations['Color'];
	      this.buttonPattern = window.stoffmuster.translations['Pattern'];
	      this.buttonPrice = window.stoffmuster.translations['Price'];
	      this.buttonWeave = window.stoffmuster.translations['Weave'];
	      this.buttonMaterial = window.stoffmuster.translations['Material'];
	      this.buttonNew = window.stoffmuster.translations['New fabrics'];
	      this.buttonTopseller = window.stoffmuster.translations['Topseller'];
	      this.buttonOccasion = window.stoffmuster.translations['Occasion'];
	      this.buttonName = window.stoffmuster.translations['Name'];
	      this.filtername = '';
	      this.classpattern = '';
	      this.classcolor = '';
	      this.classweave = '';
	      this.classmaterial = '';
	      this.classoccasion = '';
	    }
	  },
	  created: function created() {
	    this.resetButtons();
	  }
	};

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Filtersuit',
	  data: function data() {
	    return {
	      translations: window.stoffmuster.translations
	    };
	  },
	  props: {
	    showPattern: Boolean,
	    showColor: Boolean,
	    showWeave: Boolean,
	    showMaterial: Boolean,
	    showOccasion: Boolean,
	    showPrice: Boolean,
	    showSeason: Boolean,
	    showNew: Boolean,
	    showTopseller: Boolean,
	    showName: Boolean,
	    filtercolor: String,
	    buttonColor: String,
	    classcolor: String,
	    filterpattern: String,
	    buttonPattern: String,
	    classpattern: String,
	    filterweave: String,
	    buttonWeave: String,
	    classweave: String,
	    filtermaterial: String,
	    buttonMaterial: String,
	    classmaterial: String,
	    filteroccasion: String,
	    buttonOccasion: String,
	    classoccasion: String,
	    buttonNew: String,
	    buttonTopseller: String,
	    buttonPrice: String,
	    filtername: String,
	    buttonName: String,
	    range1: Object,
	    range2: Object,
	    boolfilter: Object
	  },
	  methods: {
	    selectFabric: function selectFabric(event) {
	      this.$dispatch('getFabricData', event);
	    },
	    setFilter: function setFilter(event) {
	      var t = event.currentTarget.dataset.select;
	      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1);
	      var id = event.currentTarget.id === 'all' ? '' : event.currentTarget.id;
	      var cl = 'class' + t;
	      this[cl] = id.replace('100%', 'full');
	      this[f] = false;
	      this.$dispatch('setFilter', event, function (value) {
	        var b = 'button' + t.charAt(0).toUpperCase() + t.substr(1);
	        this[b] = window.stoffmuster.translations[value];
	      }.bind(this));
	      this.$dispatch('checkDesign', event, function () {});
	    },
	    setBoolFilter: function setBoolFilter(event) {
	      var t = event.currentTarget.id.substr(0, event.currentTarget.id.indexOf('Button'));
	      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1);
	      if (this[f] === true) {
	        this[f] = false;
	      } else {
	        this.resetFilter();
	        this[f] = true;
	      }
	      this.$dispatch('setBoolFilter', event, function () {});
	      this.$dispatch('checkDesign', event, function () {});
	    },
	    resetFilter: function resetFilter(event) {
	      this.showPattern = false;
	      this.showColor = false;
	      this.showWeave = false;
	      this.showMaterial = false;
	      this.showOccasion = false;
	      this.showSeason = false;
	      this.showPrice = false;
	      this.showName = false;
	      this.$dispatch('checkDesign', event, function () {});
	    },
	    realResetFilter: function realResetFilter() {
	      this.resetFilter();
	      this.$dispatch('resetFilter');
	      this.resetButtons();
	    },
	    showFilter: function showFilter(event) {
	      var t = event.currentTarget.id.substr(0, event.currentTarget.id.indexOf('Button'));
	      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1);
	      if (this[f] === true) {
	        this[f] = false;
	      } else {
	        this.resetFilter();
	        this[f] = true;
	      }
	      this.$dispatch('checkDesign', event, function () {});
	    },
	    closeName: function closeName() {
	      this.showName = false;
	    },
	    closePrice: function closePrice() {
	      this.showPrice = false;
	    },
	    range1max: function range1max() {
	      this.range1.max = this.range2.value;
	      if (this.range1.value !== this.range1.min || this.range2.value !== this.range2.max) {
	        this.buttonPrice = this.range1.value + ' - ' + this.range2.value + ' €';
	      } else {
	        this.buttonPrice = window.stoffmuster.translations['Price'];
	      }
	    },
	    range2min: function range2min() {
	      this.range2.min = this.range1.value;
	      if (this.range1.value !== this.range1.min || this.range2.value !== this.range2.max) {
	        this.buttonPrice = this.range1.value + ' - ' + this.range2.value + ' €';
	      } else {
	        this.buttonPrice = window.stoffmuster.translations['Price'];
	      }
	    },
	    nameChange: function nameChange(event) {
	      var t = event.currentTarget.dataset.select;
	      this.$dispatch('setFilter', event, function (value) {
	        var b = 'button' + t.charAt(0).toUpperCase() + t.substr(1);
	        if (value === '') {
	          this[b] = window.stoffmuster.translations['Name'];
	        } else {
	          this[b] = value;
	        }
	      }.bind(this));
	    },
	    setPriceRange: function setPriceRange(event) {
	      var min = parseInt(event.currentTarget.dataset.start);
	      var max = parseInt(event.currentTarget.dataset.end);
	      this.range1.value = min;
	      this.range2min();
	      this.range2.value = max;
	      this.range1max();
	      this.closePrice();
	    },
	    resetButtons: function resetButtons() {
	      this.buttonColor = window.stoffmuster.translations['Color'];
	      this.buttonPattern = window.stoffmuster.translations['Pattern'];
	      this.buttonPrice = window.stoffmuster.translations['Price'];
	      this.buttonWeave = window.stoffmuster.translations['Weave'];
	      this.buttonMaterial = window.stoffmuster.translations['Material'];
	      this.buttonNew = window.stoffmuster.translations['New fabrics'];
	      this.buttonTopseller = window.stoffmuster.translations['Topseller'];
	      this.buttonOccasion = window.stoffmuster.translations['Occasion'];
	      this.buttonName = window.stoffmuster.translations['Name'];
	      this.filtername = '';
	      this.classpattern = '';
	      this.classcolor = '';
	      this.classweave = '';
	      this.classmaterial = '';
	      this.classoccasion = '';
	    }
	  },
	  created: function created() {
	    this.resetButtons();
	  }
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(2);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jQuery = __webpack_require__(7);
	exports.default = {
	  name: 'Zoom',
	  props: ['zoom', 'show', 'globals', 'muster1', 'muster2', 'muster3', 'muster4', 'isactive'],
	  data: function data() {
	    var calcBottom = (100 + (110 - parseInt(this.zoom.weight)) / 2) * -1;
	    return {
	      bottomWeight: calcBottom,
	      translations: window.stoffmuster.translations
	    };
	  },
	  methods: {
	    addSample: function addSample(event) {
	      var exists = false;
	      var message = '';
	      var free = '';
	      var keys = ['muster1', 'muster2', 'muster3', 'muster4'];
	      var i = 0;
	      var key;
	      while (keys[i]) {
	        key = keys[i];
	        if (localStorage.getItem(key)) {
	          if (event.currentTarget.dataset.refnr === JSON.parse(localStorage.getItem(key))) {
	            exists = key;
	            break;
	          }
	        } else {
	          if (!free) free = key;
	        }
	        i++;
	      }
	      if (!exists && free) {
	        localStorage.setItem(free, (0, _stringify2.default)(event.currentTarget.dataset.refnr));
	        this.$dispatch('setSwatch', { key: free, value: event.currentTarget.dataset.refnr });
	        this.isactive.push(event.currentTarget.dataset.refnr);
	        this.$dispatch('setMsg', { success: this.translations['Added to swatch box.'] });
	      } else {
	        if (exists) {
	          localStorage.removeItem(key);
	          this.$dispatch('setSwatch', { key: key, value: '' });
	          var index = this.isactive.indexOf(event.currentTarget.dataset.refnr);
	          if (index > -1) {
	            this.isactive.splice(index, 1);
	          }
	          message = this.translations['Removed from swatch box.'];
	          this.$dispatch('setMsg', { success: message });
	        } else {
	          message = this.translations['You have already four fabrics in swatch box.'];
	          this.$dispatch('setMsg', { error: message });
	        }
	      }
	    },
	    bodyZoom: function bodyZoom() {
	      if (this.show) {
	        jQuery('body').css('overflow', 'hidden');
	        jQuery('body').css('position', 'fixed');
	        jQuery('body').css('left', 0);
	        jQuery('body').css('right', 0);
	      } else {
	        jQuery('body').css('overflow', 'auto');
	        jQuery('body').css('position', 'relative');
	        jQuery('body').css('left', 'inherit');
	        jQuery('body').css('right', 'inherit');
	      }
	    }
	  },
	  watch: {
	    show: function show() {
	      this.bodyZoom();
	    }
	  },
	  created: function created() {
	    this.bodyZoom();
	  }
	};

/***/ },
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports = " <div class=swatch-designer id=konfigurator> <component :is=currentView :items=selectItems :box=selectBox :msg=msg :zoom=zoom :show.sync=showModal :personal=personal :isactive=isactive :baseurl=baseurl :translations=translations :muster1=muster1 :muster2=muster2 :muster3=muster3 :muster4=muster4 :currentdata=currentData> </component> <div class=designer-content-col> <div class=product-img-box> <div class=selection-overview> <ol class=selection-overview-size> <li class=bignumber-1><img v-if=\"url1 !== ''\" v-bind:src=url1 /> <span v-if=\"url1 !== ''\" :id=\"personal['muster1']\" @click=remove class=remove>X</span> <span v-if=\"url1 !== ''\" :id=\"personal['muster1']\" @click=zoomFabric class=collect-detail v-bind:data-refnr=\"personal['muster1']\" v-bind:data-title=\"currentData['muster1'].name\" v-bind:data-infotext=\"currentData['muster1'].infotext\" v-bind:data-price=\"currentData['muster1'].price\" v-bind:data-weave=\"currentData['muster1'].weave\" v-bind:data-yarn=\"currentData['muster1'].yarn\" v-bind:data-weight=\"currentData['muster1'].weight\" v-bind:data-composition=\"currentData['muster1'].composition\" v-bind:data-zoom=\"currentData['muster1'].zoom\"></span> </li> <li class=bignumber-2><img v-if=\"url2 !== ''\" v-bind:src=url2 /> <span v-if=\"url2 !== ''\" :id=\"personal['muster2']\" @click=remove class=remove>X</span> <span v-if=\"url2 !== ''\" :id=\"personal['muster2']\" @click=zoomFabric class=collect-detail v-bind:data-refnr=\"personal['muster2']\" v-bind:data-title=\"currentData['muster2'].name\" v-bind:data-infotext=\"currentData['muster2'].infotext\" v-bind:data-price=\"currentData['muster2'].price\" v-bind:data-weave=\"currentData['muster2'].weave\" v-bind:data-yarn=\"currentData['muster2'].yarn\" v-bind:data-weight=\"currentData['muster2'].weight\" v-bind:data-composition=\"currentData['muster2'].composition\" v-bind:data-zoom=\"currentData['muster2'].zoom\"></span> </li> <li class=bignumber-3><img v-if=\"url3 !== ''\" v-bind:src=url3 /> <span v-if=\"url3 !== ''\" :id=\"personal['muster3']\" @click=remove class=remove>X</span> <span v-if=\"url3 !== ''\" :id=\"personal['muster3']\" @click=zoomFabric class=collect-detail v-bind:data-refnr=\"personal['muster3']\" v-bind:data-title=\"currentData['muster3'].name\" v-bind:data-infotext=\"currentData['muster3'].infotext\" v-bind:data-price=\"currentData['muster3'].price\" v-bind:data-weave=\"currentData['muster3'].weave\" v-bind:data-yarn=\"currentData['muster3'].yarn\" v-bind:data-weight=\"currentData['muster3'].weight\" v-bind:data-composition=\"currentData['muster3'].composition\" v-bind:data-zoom=\"currentData['muster3'].zoom\"></span> </li> <li class=bignumber-4><img v-if=\"url4 !== ''\" v-bind:src=url4 /> <span v-if=\"url4 !== ''\" :id=\"personal['muster4']\" @click=remove class=remove>X</span> <span v-if=\"url4 !== ''\" :id=\"personal['muster4']\" @click=zoomFabric class=collect-detail v-bind:data-refnr=\"personal['muster4']\" v-bind:data-title=\"currentData['muster4'].name\" v-bind:data-infotext=\"currentData['muster4'].infotext\" v-bind:data-price=\"currentData['muster4'].price\" v-bind:data-weave=\"currentData['muster4'].weave\" v-bind:data-yarn=\"currentData['muster4'].yarn\" v-bind:data-weight=\"currentData['muster4'].weight\" v-bind:data-composition=\"currentData['muster4'].composition\" v-bind:data-zoom=\"currentData['muster4'].zoom\"></span> </li> </ol> </div> <div id=logme></div> </div> </div> <div class=infobox> <div class=\"top-step-name basic-border basic-color\">4 Stoffmuster<span class=extra_price> 3,90 &euro;</span> <span class=tax-details>{{{ priceInfo }}}</span></div> <div class=\"\"> <form :action=checkoutUrl method=post id=product_addtocart_form enctype=multipart/form-data> <input type=hidden class=\"input-text required-entry product-custom-option\" id=stoffprobe1 name=options[646] :value=\"personal['muster1']\"> <input type=hidden class=input-text id=stoffprobe2 name=options[647] :value=\"personal['muster2']\"> <input type=hidden class=input-text id=stoffprobe3 name=options[648] :value=\"personal['muster3']\"> <input type=hidden class=input-text id=stoffprobe4 name=options[649] :value=\"personal['muster4']\"> <button @click=addToCart class=\"button btn-cart\" type=button>In den Warenkorb</button> </form> </div> <div class=info-text> <div class=inner-info-text>Sie können viele Stoffe von tailorjack als Stoffmuster bestellen. Der Kaufpreis für die Stoffmuster wird Ihrem Kundenkonto bei tailorjack gutgeschrieben. Bei Ihrer nächsten Bestellung für Hemden, Blusen oder Anzüge zahlen Sie also entsprechend weniger. </div> </div> <div v-show=\"flash.error || flash.success\" v-bind:class=\"[ 'fabric-sample-popup', 'basic-bg', (flash.success ? 'flash-success' : 'flash-error')]\" id=flash> <div class=text-icon> <span class=icon></span> <div class=text>{{ flash.error }} {{ flash.success }}</div> </div> </div> </div> <zoom v-if=zoom :zoom=zoom :show.sync=show :globals=globals :muster1=muster1 :muster2=muster2 :muster3=muster3 :muster4=muster4 :isactive=isactive></zoom> </div> ";

/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports = " <div class=select-col> <div id=shibl v-bind:class=\"[ 'filter-reset-btn', 'fabric-switch', (activeType === 'shibl' ? 'basic-bg' : '') ]\" @click=loadFabrics>{{ translations['Shirt & blouse fabrics'] }} </div> <div id=suit v-bind:class=\"[ 'filter-reset-btn', 'fabric-switch', (activeType === 'suit' ? 'basic-bg' : '') ]\" @click=loadFabrics>{{ translations['Suit fabrics'] }} </div> <div class=designer-detailbox-description> </div> <filter v-if=\"activeType === 'shibl'\" :filtercolor=filtercolor :filterpattern=filterpattern :filterweave=filterweave :filtermaterial=filtermaterial :filteroccasion=filteroccasion :range1=range1 :range2=range2 :boolfilter=boolfilter :filtername=filtername></filter> <filtersuit v-if=\"activeType === 'suit'\" :filtercolor=filtercolor :filterpattern=filterpattern :filterweave=filterweave :filtermaterial=filtermaterial :filteroccasion=filteroccasion :range1=range1 :range2=range2 :boolfilter=boolfilter :filtername=filtername></filtersuit> <fabrics :baseurl=baseurl :box=box :fabrics=fabrics :filtercolor=filtercolor :filterpattern=filterpattern :filterweave=filterweave :filtermaterial=filtermaterial :filteroccasion=filteroccasion :range1=range1 :range2=range2 :boolfilter=boolfilter :fields=fields :filtername=filtername :personal=personal :muster1=muster1 :muster2=muster2 :muster3=muster3 :muster4=muster4 :showpattern=showPattern :showcolor=showColor :showweave=showWeave :showmaterial=showMaterial :showoccasion=showOccasion :showprice=showPrice :showname=showName :isactive=isactive :currentdata=currentData></fabrics> </div> ";

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = " <div class=fabric-select-btn-box> <div v-bind:class=\"[ 'top-arrow', 'hasTop', (scrollPosition > 0 && selectedScrollHeight > selectedClientHeight ? 'on' : '')]\" v-on:touchstart=touchstartup v-on:mouseenter=scrollup v-on:mouseleave=mouseleave v-on:touchend=touchend> <div class=top-arrow-text v-bind:style=\"[(scrollPosition > 0  && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> {{ translations['Scroll up for further fabrics'] }} </div> </div> <div id=\"{{ box.component }}\" class=fabric-select-btns> <div v-for=\"button in fabrics | filterBy filtercolor in 'color' | filterBy filterpattern in 'pattern' | filterBy filterweave in 'weave'| filterBy filtermaterial in 'material' | filterBy filteroccasion in 'occasion' | filterBy priceBetween | filterBy newFilter | filterBy topseller | filterBy filtername in 'name'\" v-if=\"$index < 30\" class=fabric-select-btn> <div class=fabric-select-img> <span v-bind:class=\"['mask', (isactive.indexOf(button.ref_number) > -1 ? 'active' : '') ]\"></span> <img v-bind:src=\"this.baseurl + 'media/'+ button.thumb+''\" alt=\"\" v-bind:title=button.name v-bind:class=active /> <span class=\"zoomSpan top\" @click=zoomFabric v-bind:data-refnr=button.ref_number v-bind:data-title=button.name v-bind:data-infotext=button.infotext v-bind:data-price=button.price v-bind:data-weave=button.weave v-bind:data-yarn=button.yarn v-bind:data-weight=button.weight v-bind:data-composition=button.composition v-bind:data-zoom=button.zoom> <img :src=globals.imgmagnify alt=\"\"/> </span> <button v-if=\"button.ref_number !== 'none'\" v-bind:class=\"[(isactive.indexOf(button.ref_number) > -1 ? 'removetomuster-btn' : 'addtomuster-btn'), (isactive.indexOf(button.ref_number) > -1 ? 'active' : '' )]\" type=button v-bind:data-refnr=button.ref_number @click=addSample v-bind:title=\"(isactive.indexOf(button.ref_number) > -1 ? translations['Remove from swatch box'] : translations['Insert into swatch box'] )\"><span v-if=\"(isactive.indexOf(button.ref_number) === -1)\">{{ translations['Into the box'] }}</span><span v-if=\"(isactive.indexOf(button.ref_number) > -1)\">{{ translations['Out of the box'] }}</span></button> </div> <div class=name v-bind:id=button.ref_number v-bind:data-component=box.component v-bind:data-fabric_quality=button.quality v-bind:data-price=button.price>{{ button.name }} </div> </div> </div> </div> <div v-bind:class=\"[ 'bottom-arrow', 'hasTop', (scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? '' : 'off')]\" v-on:touchstart=touchstartdown v-on:mouseenter=scrolldown v-on:mouseleave=mouseleave v-on:touchend=touchend> <div class=bottom-arrow-text v-bind:style=\"[(scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> {{ translations['Scroll down for further fabrics'] }} </div> </div> <zoom v-if=zoom :zoom=zoom :show.sync=show :globals=globals :muster1=muster1 :muster2=muster2 :muster3=muster3 :muster4=muster4 :isactive=isactive></zoom> ";

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = " <div class=filterbox-wrapper> <div id=filterbox class=select-btn-box> <button id=colorButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filtercolor === '' || typeof filtercolor === 'undefined' ? '' : 'active'), classcolor]\"> <span>{{ buttonColor }}</span> </button> <div v-show=showColor id=colorFilter class=select-btn-box> <button data-select=color id=white @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['White'] }}</span> </button> <button data-select=color id=blue @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Blue'] }}</span> </button> <button data-select=color id=black @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Black'] }}</span> </button> <button data-select=color id=pink @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Pink'] }}</span> </button> <button data-select=color id=grey @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Grey'] }}</span> </button> <button data-select=color id=brown @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Brown'] }}</span> </button> <button data-select=color id=red @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Red'] }}</span> </button> <button data-select=color id=others @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Others'] }}</span> </button> <button data-select=color id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=patternButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filterpattern === '' || typeof filterpattern === 'undefined' ? '' : 'active'), classpattern]\"> <span>{{ buttonPattern }}</span></button> <div v-show=showPattern id=patternFilter class=select-btn-box> <button data-select=pattern id=chambray @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['Chambray Look'] }}</span></button> <button data-select=pattern id=checks @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Checks'] }}</span> </button> <button data-select=pattern id=dots @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Dots'] }}</span> </button> <button data-select=pattern id=heringbone @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['Heringbone'] }}</span></button> <button data-select=pattern id=plain @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Plain'] }}</span> </button> <button data-select=pattern id=stripes @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Stripes'] }}</span> </button> <button data-select=pattern id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=priceButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (range1.value !== range1.min || range2.value !== range2.max) ? 'active' : '' ]\"> <span>{{ buttonPrice }}</span></button> <div v-show=showPrice id=priceFilter class=select-btn-box> <span class=close @click.prevent=closePrice>x</span> <button data-start=49 data-end=70 @click.prevent=setPriceRange class=\"select-btn basic-bg\">49 - 70 €</button> <button data-start=71 data-end=90 @click.prevent=setPriceRange class=\"select-btn basic-bg\">71 - 90 €</button> <button data-start=91 data-end=100 @click.prevent=setPriceRange class=\"select-btn basic-bg\">91 - 100 €</button> <button data-start=49 data-end=100 @click.prevent=setPriceRange class=\"select-btn basic-bg\">{{ translations['All'] }}</button> </div> <button id=weaveButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filterweave === '' || typeof filterweave === 'undefined' ? '' : 'active'), classweave]\"> <span>{{ buttonWeave }}</span> </button> <div v-show=showWeave id=weaveFilter class=select-btn-box> <button data-select=weave id=dobby @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Dobby'] }}</span> </button> <button data-select=weave id=fil-a-fil @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Fil-a-Fil'] }}</span> </button> <button data-select=weave id=heringbone @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['Heringbone'] }}</span></button> <button data-select=weave id=chambray @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Chambray'] }}</span> </button> <button data-select=weave id=lacoste @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Lacoste'] }}</span> </button> <button data-select=weave id=poplin @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Poplin'] }}</span> </button> <button data-select=weave id=twill @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Twill'] }}</span> </button> <button data-select=weave id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=materialButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filtermaterial === '' || typeof filtermaterial === 'undefined' ? '' : 'active'), classmaterial]\"> <span>{{ buttonMaterial }}</span> </button> <div v-show=showMaterial id=materialFilter class=select-btn-box> <button data-select=material id=100%_cotton @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['100% Cotton'] }}</span></button> <button data-select=material id=cotton_blend @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['Cotton Blend'] }}</span></button> <button data-select=material id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=new @click.prevent=setBoolFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (boolfilter['new'] !== '1' ? '' : 'active')]\"><span>{{ buttonNew }}</span> </button> <button id=topseller @click.prevent=setBoolFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (boolfilter['topseller'] !== '1' ? '' : 'active')]\"> <span>{{ buttonTopseller }}</span></button> <button id=occasionButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filteroccasion === '' || typeof filteroccasion === 'undefined' ? '' : 'active'), classoccasion]\"> <span>{{ buttonOccasion }}</span></button> <div v-show=showOccasion id=occasionFilter class=select-btn-box> <button data-select=occasion id=all_occasions @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All Occassions'] }}</span></button> <button data-select=occasion id=business_festive @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Business & Festive'] }}</span></button> <button data-select=occasion id=business_festive_casual @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Business & Festive/ Casual'] }}</span> </button> <button data-select=occasion id=leisure_festive @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Leisure & Festive'] }}</span></button> <button data-select=occasion id=leisure_casual @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Leisure/ Casual'] }}</span></button> <button data-select=occasion id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=nameButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filtername === '' || typeof filtername === 'undefined' ? '' : 'active')]\"> <span>{{ buttonName }}</span> </button> <div v-show=showName id=nameFilter class=select-btn-box> <span class=close @click.prevent=closeName>x</span> <label>{{ translations['Name'] }}</label> <div class=name-text> <input type=text data-select=name v-model=filtername @keyup=nameChange autofocus> </div> </div> </div> </div> <div class=filter-reset-btn @click=realResetFilter>{{translations['Reset filter']}}</div> ";

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = " <div class=filterbox-wrapper> <div id=filterbox class=select-btn-box> <button id=colorButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filtercolor === '' || typeof filtercolor === 'undefined' ? '' : 'active'), classcolor]\"> <span>{{ buttonColor }}</span> </button> <div v-show=showColor id=colorFilter class=select-btn-box> <button data-select=color id=black @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Black'] }}</span> </button> <button data-select=color id=brown @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Brown'] }}</span> </button> <button data-select=color id=blue @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Blue'] }}</span> </button> <button data-select=color id=grey @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Grey'] }}</span> </button> <button data-select=color id=others @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Others'] }}</span> </button> <button data-select=color id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=patternButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filterpattern === '' || typeof filterpattern === 'undefined' ? '' : 'active'), classpattern]\"> <span>{{ buttonPattern }}</span></button> <div v-show=showPattern id=patternFilter class=select-btn-box> <button data-select=pattern id=plain @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Plain'] }}</span> </button> <button data-select=pattern id=stripes @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Stripes'] }}</span> </button> <button data-select=pattern id=heringbone @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['Heringbone'] }}</span></button> <button data-select=pattern id=checks @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Checks'] }}</span> </button> <button data-select=pattern id=dots @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Dots'] }}</span> </button> <button data-select=pattern id=chambray @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['Chambray Look'] }}</span></button> <button data-select=pattern id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=priceButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (range1.value !== range1.min || range2.value !== range2.max) ? 'active' : '' ]\"> <span>{{ buttonPrice }}</span></button> <div v-show=showPrice id=priceFilter class=select-btn-box> <span class=close @click.prevent=closePrice>x</span> <button data-start=299 data-end=430 @click.prevent=setPriceRange class=\"select-btn basic-bg\">299 - 430 €</button> <button data-start=431 data-end=570 @click.prevent=setPriceRange class=\"select-btn basic-bg\">431 - 570 €</button> <button data-start=571 data-end=700 @click.prevent=setPriceRange class=\"select-btn basic-bg\">571 - 700 €</button> <button data-start=299 data-end=700 @click.prevent=setPriceRange class=\"select-btn basic-bg\">{{ translations['All'] }}</button> </div> <button id=weaveButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filterweave === '' || typeof filterweave === 'undefined' ? '' : 'active'), classweave]\"> <span>{{ buttonWeave }}</span> </button> <div v-show=showWeave id=weaveFilter class=select-btn-box> <button data-select=weave id=dobby @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Dobby'] }}</span> </button> <button data-select=weave id=fil-a-fil @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Fil-a-Fil'] }}</span> </button> <button data-select=weave id=heringbone @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['Heringbone'] }}</span></button> <button data-select=weave id=chambray @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Chambray'] }}</span> </button> <button data-select=weave id=lacoste @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Lacoste'] }}</span> </button> <button data-select=weave id=poplin @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Poplin'] }}</span> </button> <button data-select=weave id=twill @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Twill'] }}</span> </button> <button data-select=weave id=sharkskin @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Sharkskin'] }}</span> </button> <button data-select=weave id=hopsac @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Hopsac'] }}</span> </button> <button data-select=weave id=pinhead @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Pinhead'] }}</span> </button> <button data-select=weave id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=materialButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filtermaterial === '' || typeof filtermaterial === 'undefined' ? '' : 'active'), classmaterial]\"> <span>{{ buttonMaterial }}</span> </button> <div v-show=showMaterial id=materialFilter class=select-btn-box> <button data-select=material id=100%_wool @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['100% Wool'] }}</span></button> <button data-select=material id=wool_blend @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['Wool Blend'] }}</span></button> <button data-select=material id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=new @click.prevent=setBoolFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (boolfilter['new'] !== '1' ? '' : 'active')]\"><span>{{ buttonNew }}</span> </button> <button id=topseller @click.prevent=setBoolFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (boolfilter['topseller'] !== '1' ? '' : 'active')]\"> <span>{{ buttonTopseller }}</span></button> <button id=occasionButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filteroccasion === '' || typeof filteroccasion === 'undefined' ? '' : 'active'), classoccasion]\"> <span>{{ buttonOccasion }}</span></button> <div v-show=showOccasion id=occasionFilter class=select-btn-box> <button data-select=occasion id=all_occasions @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All Occassions'] }}</span></button> <button data-select=occasion id=business_festive @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Business & Festive'] }}</span></button> <button data-select=occasion id=business_festive_casual @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Business & Festive/ Casual'] }}</span> </button> <button data-select=occasion id=leisure_festive @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Leisure & Festive'] }}</span></button> <button data-select=occasion id=leisure_casual @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Leisure/ Casual'] }}</span></button> <button data-select=occasion id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=nameButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filtername === '' || typeof filtername === 'undefined' ? '' : 'active')]\"> <span>{{ buttonName }}</span> </button> <div v-show=showName id=nameFilter class=select-btn-box> <span class=close @click.prevent=closeName>x</span> <label>{{ translations['Name'] }}</label> <div class=name-text> <input type=text data-select=name v-model=filtername @keyup=nameChange autofocus> </div> </div> </div> </div> <div class=filter-reset-btn @click=realResetFilter>{{translations['Reset filter']}}</div> ";

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports = " <div v-if=zoom class=modal-mask v-show=show transition=modal> <div class=modal-wrapper> <div class=modal-fabric-container> <button class=modal-close-button @click=\"this.show = false\">schließen</button> <div class=modal-image v-bind:style=\"'background-image: url( '+ zoom.img +' )'\"></div> <div class=modal-text> <div class=modal-titlebox> <button v-bind:class=\"[(isactive.indexOf(zoom.refnr) > -1 ? 'removetomuster-btn' : ''), 'basic-bg']\" v-bind:id=zoom.refnr v-bind:data-refnr=zoom.refnr @click=addSample></button> <div class=modal-title>{{ zoom.title }}</div> <div v-if=zoom.composition class=modal-subtitle>{{ translations[zoom.composition] }}</div> </div> <p>{{ zoom.infotext }}</p> <div class=info-itembox> <div class=info-item v-if=\"zoom.weight > 0\"> <div class=info-title>Gewicht</div> <div class=info-icon> <div class=darkbg></div> <div class=mask v-bind:style=\"{ bottom: bottomWeight + '%' }\"></div> <img :src=globals.imgweight alt=\"\"/></div> <span>{{ zoom.weight }} g</span> </div> <div class=info-item v-if=zoom.yarn> <div class=info-title>Garn</div> <div class=\"info-icon garn\"><img :src=globals.imggarn alt=\"\"/></div> <span>{{ translations[zoom.yarn] }}</span> </div> <div class=info-item v-if=zoom.weave> <div class=info-title>Webart</div> <div class=\"info-icon webart\"><img :src=globals.imgweave alt=\"\"/></div> <span>{{ translations[zoom.weave] }}</span> </div> </div> </div> </div> </div> </div> ";

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(46)
	__vue_script__ = __webpack_require__(12)
	__vue_template__ = __webpack_require__(47)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(13)
	__vue_template__ = __webpack_require__(48)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(14)
	__vue_template__ = __webpack_require__(49)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(15)
	__vue_template__ = __webpack_require__(50)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(16)
	__vue_template__ = __webpack_require__(51)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }
]);


// WEBPACK FOOTER //
// static/stoffmuster/js/app.8f5b033adc8c1618c250.js